import { beneficialOwnersSectionValidationMap } from 'dzb/inquiry/steps/personalData/sections/beneficialOwnersSection/validations';
import { contactPersonSectionValidationMap } from 'dzb/inquiry/steps/personalData/sections/contactPersonSection/validations';
import { legalRepresentativesSectionValidationMap } from 'dzb/inquiry/steps/personalData/sections/legalRepresentativesSection/validations';

export const dzbPersonalDataSection = {
  ...contactPersonSectionValidationMap,
  ...legalRepresentativesSectionValidationMap,
  ...beneficialOwnersSectionValidationMap,
};
